import {createDataSource} from '@/models/data-source'
//const dataSource = createDataSource();
export default {
  dataSource: {},
  dataSources: [],
  allDataSources: [],
  aceEditor: null,
  loading: false,
  projectId: 0,
  relatedSources: [],
  relatedSourcesFound: 0,
  pageSize: 100,
  tables: {
    size: 0,
    results: []
  },
  dialog: false,
  mergeDialog: false,
  connection: {},
  connections: [],
  types: [
  //  {id: "paste", group: "input", name: "Paste", icon: "paste", src: "/assets/icons/plugins/ui/icons/sql/txn_auto@2x.png"},
    {id: "upload-file", group: "input", name: "CSV", icon: "file", src: "/assets/icons/plugins/generic/icons/csv_icon_big.png"},
    {id: "upload-file", group: "input", name: "Excel", icon: "file", src: "/assets/icons/plugins/office/icons/excel@2x.png"},
  //  {id: "url", group: "input", name: "From URL", icon: "web", src: "/assets/icons/plugins/ui/icons/file/link@2x.png"},
    {id: "jdbc:connection:postgresql", group: "input", name: "SQL", icon: "sql", src: "/assets/icons/plugins/ui/icons/sql/sql_preview@2x.png"},
    {id: "jdbc:connection:postgresql:view", group: "input", name: "View", icon: "sql", src: "/assets/icons/plugins/ui/icons/sql/sql_preview@2x.png"},
  //  {id: "samples", group: "input", name: "Try Our Samples", icon: "samples", src: "/assets/icons/plugins/ui/icons/sql/table_import@2x.png"},
  //  {id: "union_view", group: "union_view", name: "Merge Worksheets", icon: "samples", src: "/assets/icons/plugins/ui/icons/sql/table_import@2x.png"},
  //   {id: "athena", group: "connection", name: "Athena", description: "", src: "/assets/icons/plugins/athena/icons/athena_icon_big.png"},
//  {id: "jdbc:connection:azure", group: "connection", name: "Azure SQL Server", description: "", src: "/assets/icons/plugins/mssql/icons/azure_icon_big.png"},
  //  {id: "jdbc:connection:mariadb", group: "connection", name: "MariaDB", description: "", src: "/assets/icons/plugins/mysql/icons/mariadb_icon_big.png"},
//    {id: "jdbc:connection:mysql", group: "connection", name: "MySQL", description: "", src: "/assets/icons/plugins/mysql/icons/mysql_icon_big.png"},
    //{id: "prestodb", group: "input", name: "Presto DB", description: "", src: "/assets/icons/plugins/generic/icons/presto_icon_big.png"},
//    {id: "jdbc:connection:mssql", group: "connection", name: "SQL Server", description: "", src: "/assets/icons/plugins/mssql/icons/mssql_icon_big.png"},
  //  {id: "samples", group: "input", name: "SyBase", description: "", src: "/assets/icons/plugins/mssql/icons/sybase_icon_big.png"},
//    {id: "jdbc:connection:postgresql", group: "connection", name: "PostrgeSQL", description: "", src: "/assets/icons/plugins/postgresql/icons/postgresql_icon_big.png"},
//    {id: "jdbc:connection:cockroachdb", group: "connection", name: "Cocroach DB", description: "", src: "/assets/icons/plugins/postgresql/icons/cockroach_icon_big.png"},
//    {id: "jdbc:connection:timescale", group: "connection", name: "Timescale", description: "", src: "/assets/icons/plugins/postgresql/icons/timescale_icon_big.png"},
  //  {id: "jdbc:connection:redshift", group: "connection", name: "Redshift", description: "", src: "/assets/icons/plugins/postgresql/icons/redshift_icon_big.png"},
    // {id: "samples", group: "input", name: "Yellow Brick", description: "", src: "/assets/icons/plugins/postgresql/icons/yellowbrick_icon_big.png"}
  ],
  pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 20,
      totalItems: 0,
      rowsPerPageItems: [20, 40, 60, 100]
    }
}
